<!--
  Shell comes from src/dialogs.css: the `.title` block MUST stay the first
  child of the root, and the root carries no padding / background / border of
  its own. See AGENTS.md "Dialogs - one shell".
-->
<div>
  <div class="title">
    <h2 class="primary" i18n="@@draftPartitionTitle">This Draft no longer matches its Project</h2>
    <h3>{{ propertyLabel }}</h3>
  </div>

  <div class="text-inside">
    <p i18n="@@draftPartitionLead">You changed a setting that normally keeps Projects apart.</p>

    <div class="partition-compare">
      <div class="partition-row">
        <span class="partition-label" i18n="@@This Draft">This Draft</span>
        <span class="partition-value">{{ newValueLabel }}</span>
      </div>
      <div class="partition-row">
        <span class="partition-label" *ngIf="projectName">{{ projectName }}</span>
        <span class="partition-label" *ngIf="!projectName" i18n="@@This Project">This Project</span>
        <span class="partition-value">{{ projectValueLabel }}</span>
      </div>
    </div>

    <p i18n="@@draftPartitionQuestion">Keep it in this Project, or move it to a new one?</p>
    <p class="partition-note" i18n="@@draftPartitionNote">A Project can hold a mix. You can change this at any time.</p>
  </div>

  <!-- Dismiss-equivalent first, structural action last. Keeping the Draft
       where it is changes nothing, so it is the safe left-hand button. -->
  <div class="btn-sec">
    <button mat-raised-button type="button" class="Discard-btn" (click)="keep()"
            i18n="@@Keep in This Project">Keep in This Project</button>
    <button mat-raised-button type="button" color="primary" class="Update-btn" (click)="move()"
            i18n="@@Move to a New Project">Move to a New Project</button>
  </div>
</div>
